import type { ReactNode } from "react";

type Tone = "neutral" | "success" | "warning" | "danger" | "info" | "primary";

interface Props {
  tone: Tone;
  children: ReactNode;
  icon?: ReactNode;
}

/** Coloured pill used across status columns. Variants map to design-system colours. */
export function StatusPill({ tone, children, icon }: Props) {
  return (
    <span className={`status-pill status-pill--${tone}`}>
      {icon && <span aria-hidden="true">{icon}</span>}
      {children}
    </span>
  );
}
